import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {Route, Routes} from "react-router";
import {route} from "../../../../routes";
import {Helmet} from "react-helmet";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";

import VenuesTranslateManageController from "../../controllers/translate/VenuesTranslateManageController";
import VenuesTranslateAmendedController from "../../controllers/translate/VenuesTranslateAmendedController";
import VenuesTranslateDraftController from "../../controllers/translate/VenuesTranslateDraftController";

import {TRANSLATOR_UNASSIGNED} from "../../../../constants";
import {Modal, withAuthentication} from "cw-styleguide-react";
class VenuesTranslateView extends Component {


  render() {
    return (

      <Fragment>

        <Helmet>
          <title>{this.props.t('local:view.venues.translateManage.title')}</title>
        </Helmet>

        <BreadcrumbsItem to={route('venuesTranslateManage')}>
          {this.props.t('view.venues.translateManage.breadcrumb')}
        </BreadcrumbsItem>

        {/* Assign to me Modal */}
        <Modal
          show={this.props.modals.assign}
          title={this.props.t('local:view.venues.manage.modals.assignToMe.title')}
          onCancel={() => this.props.toggleModal(['assign'], false)}
          onConfirm={() => this.props.assignVenue([this.props.values.id],  this.props.authentication.getClaim('atlasId'), true)}
          ariaLabelCancel={this.props.t('local:view.venues.manage.modals.assignToMe.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.venues.manage.modals.assignToMe.ariaLabelConfirm')}
          html={this.props.t('local:view.venues.manage.modals.assignToMe.description', {count:1})}
        />

        {/* Reassign Modal */}
        <Modal
          show={this.props.modals.unassign}
          title={this.props.t('local:view.venues.manage.modals.reassignTranslation.title')}
          onCancel={() => this.props.toggleModal(['unassign'], false)}
          onConfirm={() => this.props.assignVenue([this.props.values.id], TRANSLATOR_UNASSIGNED, true)}
          ariaLabelCancel={this.props.t('local:view.venues.manage.modals.reassignTranslation.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.venues.manage.modals.reassignTranslation.ariaLabelConfirm')}
          html={this.props.t('local:view.venues.manage.modals.reassignTranslation.description', {count:1})}
       />

     {/* Assign to me Modal */}
     <Modal
          show={this.props.modals.bulkAssign}
          title={this.props.t('local:view.venues.manage.modals.assignToMe.title')}
          onCancel={() => this.props.toggleModal(['bulkAssign'], false)}
          onConfirm={() => this.props.assignVenue(this.props.selected,  this.props.authentication.getClaim('atlasId'), true)}
          ariaLabelCancel={this.props.t('local:view.venues.manage.modals.assignToMe.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.venues.manage.modals.assignToMe.ariaLabelConfirm')}
          html={this.props.t('local:view.venues.manage.modals.assignToMe.description', {count:this.props.selected.size})}
        />

        {/* Reassign Modal */}
        <Modal
          show={this.props.modals.bulkUnassign}
          title={this.props.t('local:view.venues.manage.modals.reassignTranslation.title')}
          onCancel={() => this.props.toggleModal(['bulkUnassign'], false)}
          onConfirm={() => this.props.assignVenue(this.props.selected, TRANSLATOR_UNASSIGNED, true)}
          ariaLabelCancel={this.props.t('local:view.venues.manage.modals.reassignTranslation.ariaLabelCancel')}
          ariaLabelConfirm={this.props.t('local:view.venues.manage.modals.reassignTranslation.ariaLabelConfirm')}
          html={this.props.t('local:view.venues.manage.modals.reassignTranslation.description', {count:this.props.selected.size})}
        />

        <Routes>
          <Route index
                 element={ <VenuesTranslateManageController  {...this.props} />}/>
          <Route path={route('venuesTranslateDraft')} exact={true}
                 element={ <VenuesTranslateDraftController  {...this.props}  />}/>
          <Route path={route('venuesTranslateAmended')} exact={true}
                 element={ <VenuesTranslateAmendedController {...this.props}  />}/>

        </Routes>

      </Fragment>
    )
  }

}

export default withAuthentication( withTranslation('local')(VenuesTranslateView));
